import { render, staticRenderFns } from "./SystemAdmin.vue?vue&type=template&id=20d14d28"
import script from "./SystemAdmin.vue?vue&type=script&lang=js"
export * from "./SystemAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d14d28')) {
      api.createRecord('20d14d28', component.options)
    } else {
      api.reload('20d14d28', component.options)
    }
    module.hot.accept("./SystemAdmin.vue?vue&type=template&id=20d14d28", function () {
      api.rerender('20d14d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Systems/SystemAdmin.vue"
export default component.exports